module.exports = __webpack_public_path__ + "img/Home_Bild4.b683f7a1.jpg";